import Phaser from 'phaser';
import { GAME_CONFIG } from '../config/game';
import { hasSave, loadGame } from '../systems/SaveState';
import { getSoundSystem } from '../systems/SoundSystem';
import { getMusicPlayer } from '../systems/MusicPlayer';
import { BackHandler, pushSceneState } from '../systems/BackButton';

export class TitleScene extends Phaser.Scene implements BackHandler {
  constructor() {
    super('TitleScene');
  }

  handleBack(): void {}

  create(): void {
    pushSceneState();
    getMusicPlayer().startMenu();

    const centerX = GAME_CONFIG.width / 2;
    const centerY = GAME_CONFIG.height / 2;

    this.add.text(centerX, centerY - 180, 'Lithoform', {
      fontSize: '42px',
      color: '#a8e6cf',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5);

    this.add.text(centerX, centerY - 130, 'Restore the land', {
      fontSize: '16px',
      color: '#888888',
      fontFamily: 'sans-serif',
    }).setOrigin(0.5);

    const playBtn = this.add.text(centerX, centerY - 40, 'Play', {
      fontSize: '24px',
      color: '#1a1a2e',
      fontFamily: 'sans-serif',
      backgroundColor: '#a8e6cf',
      padding: { x: 48, y: 16 },
    }).setOrigin(0.5).setInteractive();

    playBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      if (hasSave()) {
        const saveData = loadGame();
        if (saveData) {
          this.scene.start('GameScene', { saveData });
          return;
        }
      }
      this.scene.start('WorldMapScene');
    });

    const dailyBtn = this.add.text(centerX, centerY + 40, 'Daily Challenge', {
      fontSize: '20px',
      color: '#f0d060',
      fontFamily: 'sans-serif',
      padding: { x: 32, y: 12 },
    }).setOrigin(0.5).setInteractive();

    dailyBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start('DailyCalendarScene');
    });

    const storyBtn = this.add.text(centerX, centerY + 110, 'Story', {
      fontSize: '20px',
      color: '#a8e6cf',
      fontFamily: 'sans-serif',
      padding: { x: 32, y: 12 },
    }).setOrigin(0.5).setInteractive();

    storyBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start('StoryScene');
    });

    const howToPlayBtn = this.add.text(centerX, centerY + 180, 'How to Play', {
      fontSize: '20px',
      color: '#a8e6cf',
      fontFamily: 'sans-serif',
      padding: { x: 32, y: 12 },
    }).setOrigin(0.5).setInteractive();

    howToPlayBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start('HowToPlayScene', { returnTo: 'TitleScene' });
    });

    const settingsBtn = this.add.text(centerX, centerY + 250, 'Settings', {
      fontSize: '20px',
      color: '#a8e6cf',
      fontFamily: 'sans-serif',
      padding: { x: 32, y: 12 },
    }).setOrigin(0.5).setInteractive();

    settingsBtn.on('pointerdown', () => {
      getSoundSystem().playBlip();
      this.scene.start('SettingsScene', { returnTo: 'TitleScene' });
    });
  }
}
